import { faEye, faFileLines } from '@fortawesome/free-solid-svg-icons';

export const ICONS = {
  eye: faEye,
  log: faFileLines,
};

export const ERROR_MESSAGES = {
  FETCH_LOGS: 'Failed to fetch logs. Please try again later.',
  FETCH_DEVICES: 'Failed to fetch devices. Please try again later.',
  FETCH_MERCHANTS: 'Failed to fetch merchants. Please try again later.',
  GENERIC: 'An error occurred. Please try again.',
};

export const EMPTY_STATES = {
  NO_LOGS: 'No logs found.',
  NO_DEVICES: 'No devices available.',
  NO_MERCHANTS: 'No merchants available.',
};

export const PAGE_SIZE_OPTIONS = [10, 20, 30, 50, 100];
export const DEFAULT_PAGE_SIZE = 10;
